module.exports = __webpack_public_path__ + "img/verified.0211fed0.svg";